import EA from 'helpers/init';
import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

export default EA.Methods.heroIntroAnim = ($this) => {
    const titleEl = $this.querySelector('.hero-title');
    const text = $this.querySelector('.hero-text');
    const scrollWrap = $this.querySelector('.hero-scroll-wrap');
    const floatingBar = document.querySelector('.floating-bar');
    const floatingBarText = document.querySelector('.floating-bar-text');

    const splitLines = new SplitText(titleEl, { type: 'lines' });
    const splitChars = new SplitText(splitLines.lines, { type: 'chars' });

    gsap.config({ nullTargetWarn: false });

    gsap.timeline()
        .from(splitChars.chars, {
            y: 10,
            alpha: 0,
            duration: 0.5,
            stagger: 0.025,
            delay: 0.6,
            ease: 'power3.out',
            onComplete: () => {
                splitChars.revert();
                splitLines.revert();
            }
        })
        .from(text, {
            alpha: 0,
            duration: 0.6,
            ease: 'power2.out',
            clearProps: 'all'
        }, '-=0.2')
        .from(scrollWrap, {
            alpha: 0,
            duration: 0.6,
            ease: 'power2.out',
            clearProps: 'all'
        }, '-=0.3')
        .from(floatingBar, {
            alpha: 0,
            duration: 0.6,
            ease: 'power2.out',
            clearProps: 'all'
        }, '-=0.3')
        .from(floatingBarText, {
            width: 0,
            duration: 0.6,
            ease: 'power2.out',
            clearProps: 'all'
        }, '-=0.2');
};
